import siteConfig from "../config/siteConfig";

const waistSizes = [
  "W29 / L32",
  "W30 / L32",
  "W31 / L32",
  "W32 / L32",
  "W33 / L32",
  "W34 / L32",
  "W34 / L34",
  "W36 / L34",
  "W38 / L34",
];

const shortSizes = ["W30", "W31", "W32", "W33", "W34", "W36", "W38"];
const origin = "Country of manufacture: refer to the garment label";

const catalog = [
  {
    id: 1,
    sku: "DOM01S-A32-0638-102",
    name: "DOM01S Slim Fit Jeans — Deep Indigo",
    category: "Denim",
    collection: "SS26",
    price: 199,
    color: "Deep Indigo",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "92% cotton, 6% elastomultiester, 2% elastane",
    fabricCode: "1-0638-DEN",
    description:
      "A clean, close-cut five-pocket jean with enough stretch for all-day ease and a deep indigo wash that softens beautifully over time.",
    tags: ["slim", "stretch", "best-seller"],
  },
  {
    id: 2,
    sku: "DOM01S-A25-0638-108",
    name: "DOM01S Slim Fit Jeans — Light Wash",
    category: "Denim",
    collection: "SS26",
    price: 199,
    color: "Light Blue",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "92% cotton, 6% elastomultiester, 2% elastane",
    fabricCode: "1-0638-DEN",
    description:
      "Our signature slim jean in a sun-faded blue wash, built with recovery stretch so the shape stays sharp from morning to evening.",
    tags: ["slim", "light-wash", "stretch"],
  },
  {
    id: 3,
    sku: "DOM01S-A35-1484-103",
    name: "DOM01S Slim Fit Jeans — Grey Denim",
    category: "Denim",
    collection: "SS26",
    price: 199,
    color: "Washed Grey",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "97% organic cotton, 3% elastane",
    fabricCode: "1-1484-DEN",
    description:
      "A versatile grey denim with subtle fading and a neat tapered silhouette, finished with low-profile hardware and tonal stitching.",
    tags: ["slim", "grey", "organic-cotton"],
  },
  {
    id: 4,
    sku: "DOM01RG-A49-1484-103",
    name: "DOM01RG Relaxed Fit Jeans — Ecru",
    category: "Denim",
    collection: "SS26",
    price: 199,
    color: "Ecru",
    fit: "Relaxed",
    leg: "Straight leg",
    composition: "97% organic cotton, 3% elastane",
    fabricCode: "1-1484-DEN",
    description:
      "A softly structured ecru jean with more room through the thigh and a modern straight leg for effortless warm-weather dressing.",
    tags: ["relaxed", "ecru", "organic-cotton"],
  },
  {
    id: 5,
    sku: "DOM01RG-A100-1333-102",
    name: "DOM01RG Relaxed Fit Jeans — Light Blue",
    category: "Denim",
    collection: "SS26",
    price: 209,
    color: "Cloud Blue",
    fit: "Relaxed",
    leg: "Straight leg",
    composition: "92% cotton, 6% elastomultiester, 2% elastane",
    fabricCode: "1-1333-DEN",
    description:
      "A comfortable relaxed-fit jean in an airy cloud-blue wash, balanced by a clean waist and considered back-pocket placement.",
    tags: ["relaxed", "light-blue", "new"],
  },
  {
    id: 6,
    sku: "DOM01RG-A61-0638-101",
    name: "DOM01RG Regular Fit Jeans — Dark Denim",
    category: "Denim",
    collection: "Core",
    price: 199,
    color: "Dark Denim",
    fit: "Regular",
    leg: "Soft taper",
    composition: "92% cotton, 6% elastomultiester, 2% elastane",
    fabricCode: "1-0638-DEN",
    description:
      "The dependable regular fit: easy through the seat and thigh, gently tapered below the knee, and washed to a rich dark blue.",
    tags: ["regular", "dark-blue", "core"],
  },
  {
    id: 7,
    sku: "DOM05-A60-1589-730",
    name: "DOM05 Slim Fit Chino — Sand",
    category: "Chino",
    collection: "SS26",
    price: 199,
    color: "Sand",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "96% cotton, 4% elastane",
    fabricCode: "1-1589-RTD",
    description:
      "A refined sand chino with a smooth stretch twill, tailored waistband and a slim line that works equally well dressed up or down.",
    tags: ["slim", "sand", "best-seller"],
  },
  {
    id: 8,
    sku: "DOM05-A76-1878-803",
    name: "DOM05 Slim Fit Chino — Navy",
    category: "Chino",
    collection: "Core",
    price: 199,
    color: "Deep Navy",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "97% cotton, 3% elastane",
    fabricCode: "1-1878-RTD",
    description:
      "Our everyday navy chino, cut close without feeling restrictive and finished with understated internal tailoring details.",
    tags: ["slim", "navy", "core"],
  },
  {
    id: 9,
    sku: "DOM05-A82-1589-735",
    name: "DOM05 Slim Fit Chino — Olive",
    category: "Chino",
    collection: "SS26",
    price: 199,
    color: "Olive",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "96% cotton, 4% elastane",
    fabricCode: "1-1589-RTD",
    description:
      "Garment-dyed olive twill gives this slim chino nuanced colour, while compact stretch cotton keeps the surface polished.",
    tags: ["slim", "olive", "garment-dyed"],
  },
  {
    id: 10,
    sku: "DOM05-A34-1949-111",
    name: "DOM05 Slim Fit Chino — Pale Stone",
    category: "Chino",
    collection: "SS26",
    price: 189,
    color: "Pale Stone",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "97% cotton, 3% elastane",
    fabricCode: "1-1949-RTD",
    description:
      "A light neutral chino designed for tonal spring dressing, with a crisp hand, gentle stretch and signature shaped waistband.",
    tags: ["slim", "neutral", "ss26"],
  },
  {
    id: 11,
    sku: "DOM02-A03-1730-105",
    name: "DOM02 Modern Fit Trousers — Sky Blue",
    category: "Tailored",
    collection: "Gold Line",
    price: 209,
    color: "Sky Blue",
    fit: "Modern",
    leg: "Straight leg",
    composition: "54% cotton, 44% linen, 2% elastane",
    fabricCode: "1-1730-RTD",
    description:
      "Softly tailored trousers in a fresh sky blue, with a modern straight profile, pressed crease and discreet stretch for movement.",
    tags: ["modern", "blue", "linen-blend"],
  },
  {
    id: 12,
    sku: "DOM02-A04-1730-106",
    name: "DOM02 Modern Fit Trousers — Warm Beige",
    category: "Tailored",
    collection: "Gold Line",
    price: 209,
    color: "Warm Beige",
    fit: "Modern",
    leg: "Straight leg",
    composition: "54% cotton, 44% linen, 2% elastane",
    fabricCode: "1-1730-RTD",
    description:
      "A warm beige tailored trouser with an elegant pressed front and easy modern fit, woven in a breathable cotton-linen blend.",
    tags: ["modern", "beige", "linen-blend"],
  },
  {
    id: 13,
    sku: "DOM03-A08-2033-104",
    name: "Fine Check Tailored Trousers — Light Grey",
    category: "Tailored",
    collection: "Gold Line",
    price: 219,
    color: "Light Grey Check",
    fit: "Modern",
    leg: "Straight leg",
    composition: "53% recycled polyester, 43% wool, 4% elastane",
    fabricCode: "1-2033-RTD",
    description:
      "A subtle micro-check gives these light grey trousers depth while maintaining the quiet versatility of a solid tailored pair.",
    tags: ["modern", "check", "grey", "recycled-fibre"],
  },
  {
    id: 14,
    sku: "DOM03-A09-2035-103",
    name: "Fine Check Tailored Trousers — Deep Blue",
    category: "Tailored",
    collection: "Gold Line",
    price: 219,
    color: "Deep Blue Check",
    fit: "Modern",
    leg: "Straight leg",
    composition: "52% wool, 44% recycled polyester, 4% elastane",
    fabricCode: "1-2035-RTD",
    description:
      "Deep blue checked trousers with a precise crease and clean waist construction, made to bridge business and relaxed occasions.",
    tags: ["modern", "check", "blue", "gold-line"],
  },
  {
    id: 15,
    sku: "DOM03-A10-2037-101",
    name: "Slim Fit Stretch Trousers — Ecru",
    category: "Tailored",
    collection: "Authentic",
    price: 199,
    color: "Ecru",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "63% cotton, 34% lyocell, 3% elastane",
    fabricCode: "1-2037-RTD",
    description:
      "A polished ecru trouser with the comfort of a chino and the crisp finishing of tailoring, cut in our reliable slim fit.",
    tags: ["slim", "ecru", "lyocell"],
  },
  {
    id: 16,
    sku: "DOM03-A11-2042-928",
    name: "Slim Fit Stretch Trousers — Light Grey",
    category: "Tailored",
    collection: "Authentic",
    price: 199,
    color: "Light Grey",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "64% cotton, 33% lyocell, 3% elastane",
    fabricCode: "1-2042-RTD",
    description:
      "Clean light grey trousers in a soft compact weave, engineered for recovery and finished with understated tonal details.",
    tags: ["slim", "grey", "stretch"],
  },
  {
    id: 17,
    sku: "DOM05-A71-1866-723",
    name: "Slim Fit Corduroy — Taupe",
    category: "Corduroy",
    collection: "Urban",
    price: 209,
    color: "Taupe",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "98% cotton, 2% elastane",
    fabricCode: "1-1866-RTD",
    description:
      "Fine-wale taupe corduroy gives warmth without bulk, shaped into a clean slim trouser that works with knitwear or an unstructured jacket.",
    tags: ["slim", "taupe", "urban"],
  },
  {
    id: 18,
    sku: "DOM05-A73-1866-906",
    name: "Slim Fit Corduroy — Charcoal",
    category: "Corduroy",
    collection: "Urban",
    price: 209,
    color: "Charcoal",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "98% cotton, 2% elastane",
    fabricCode: "1-1866-RTD",
    description:
      "A charcoal fine-cord trouser with a refined, velvety surface and discreet stretch, tailored to keep its shape through regular wear.",
    tags: ["slim", "charcoal", "urban"],
  },
  {
    id: 19,
    sku: "DOM05-A88-2040-731",
    name: "Linen-Cotton Sport Trousers — Sage",
    category: "Chino",
    collection: "SS26",
    price: 219,
    color: "Sage",
    fit: "Relaxed",
    leg: "Soft taper",
    composition: "55% linen, 44% cotton, 1% elastane",
    fabricCode: "1-2040-RTD",
    description:
      "Relaxed sage trousers in a breathable linen-cotton weave, with a softly elasticated back waist hidden within a tailored profile.",
    tags: ["relaxed", "sage", "linen"],
  },
  {
    id: 20,
    sku: "DOM05-A90-2037-806",
    name: "Sport Trousers — Deep Navy",
    category: "Chino",
    collection: "Urban",
    price: 199,
    color: "Deep Navy",
    fit: "Relaxed",
    leg: "Soft taper",
    composition: "63% cotton, 34% lyocell, 3% elastane",
    fabricCode: "1-2037-RTD",
    description:
      "An easy navy trouser with hidden comfort at the waist, slanted front pockets and a clean city-ready line.",
    tags: ["relaxed", "navy", "comfort-waist"],
  },
  {
    id: 21,
    sku: "DOM03-A18-2035-732",
    name: "Pleated Chino — Tobacco",
    category: "Chino",
    collection: "Authentic",
    price: 209,
    color: "Tobacco",
    fit: "Regular",
    leg: "Tapered leg",
    composition: "97% cotton, 3% elastane",
    fabricCode: "1-2035-RTD",
    description:
      "A single-pleat chino in a warm tobacco tone, with extra room at the top and a precise taper that keeps the silhouette contemporary.",
    tags: ["regular", "pleated", "tobacco"],
  },
  {
    id: 22,
    sku: "DOM07-A20-2040-504",
    name: "Linen Bermuda — Powder Blue",
    category: "Bermuda",
    collection: "SS26",
    price: 169,
    color: "Powder Blue",
    fit: "Regular",
    leg: "Above-knee short",
    composition: "55% linen, 44% cotton, 1% elastane",
    fabricCode: "1-2040-RTD",
    description:
      "A polished powder-blue Bermuda in breathable linen blend, cut just above the knee with a tailored waistband and easy leg.",
    tags: ["regular", "blue", "linen", "summer"],
  },
  {
    id: 23,
    sku: "DOM07-A21-2033-901",
    name: "Tailored Bermuda — Light Grey",
    category: "Bermuda",
    collection: "SS26",
    price: 169,
    color: "Light Grey",
    fit: "Modern",
    leg: "Above-knee short",
    composition: "53% recycled polyester, 43% wool, 4% elastane",
    fabricCode: "1-2033-RTD",
    description:
      "Light grey tailored shorts with a sharp front crease and discreet elastic recovery, designed for a refined summer wardrobe.",
    tags: ["modern", "tailored", "grey", "summer"],
  },
  {
    id: 24,
    sku: "DOM05-A96-0638-115",
    name: "Travel Chino — Dusty Rose",
    category: "Chino",
    collection: "SS26",
    price: 199,
    color: "Dusty Rose",
    fit: "Slim",
    leg: "Tapered leg",
    composition: "61% cotton, 36% recycled polyamide, 3% elastane",
    fabricCode: "1-0638-RTD",
    description:
      "A softly coloured travel chino with resilient stretch and a clean tapered fit, created for long days, light packing and easy combinations.",
    tags: ["slim", "rose", "travel"],
  },
];

const productData = catalog.map((product) => {
  const isShort = product.category === "Bermuda";
  const image = `/img/product-${String(product.id).padStart(2, "0")}.jpg`;

  return {
    ...product,
    brand: siteConfig.brandName,
    image,
    images: [image],
    size: isShort ? shortSizes : waistSizes,
    colors: [product.color],
    material: product.composition,
    attributes: {
      fit: product.fit,
      rise: isShort ? "Mid rise" : "Regular rise",
      leg: product.leg,
      composition: product.composition,
      origin,
      fabricCode: product.fabricCode,
      care: product.category === "Tailored" ? "Professional dry clean" : "Wash at 30°C, inside out",
    },
    tags: [product.category.toLowerCase(), ...product.tags],
    features: [
      `${product.fit} fit`,
      product.leg,
      origin,
      `Fabric reference ${product.fabricCode}`,
    ],
  };
});

export default productData;
